module.exports = __webpack_public_path__ + "static/media/simpals.bfa47274.svg";